import React, { useState } from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect, useSelector } from "react-redux";
import {
  EditOutlined,
  LogoutOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import { signOut } from "store/slices/authSlice";

const menuItem = [
  {
    title: "Edit Profile",
    icon: EditOutlined,
    path: "/app/dashboards/profile",
  },
];

export const NavProfile = ({ signOut }) => {
  const { user } = useSelector((state) => state.auth);
  const [signingOut, setSigningOut] = useState(false);

  const profileImg = "/img/profile.svg";

  const profileMenuItems = [
    ...menuItem.map((el, i) => ({
      key: String(i),
      label: (
        <a href={el.path}>
          <Icon type={el.icon} />
          <span className="font-weight-normal ml-2">{el.title}</span>
        </a>
      ),
    })),
    {
      key: String(menuItem.length + 1),
      disabled: signingOut,
      label: (
        <span>
          {signingOut ? <LoadingOutlined /> : <LogoutOutlined />}
          <span className="font-weight-normal ml-2">Sign Out</span>
        </span>
      ),
      onClick: () => {
        setSigningOut(true);
        signOut();
      },
    },
  ];

  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={user.displayImage || profileImg} />
          <div className="pl-3">
            <h4 className="mb-0">{user.firstName}</h4>
            <span className="text-muted">
              {user.userType === "Sub-admin" ? "User" : user.userType}
            </span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu items={profileMenuItems} />
      </div>
    </div>
  );

  return (
    <Dropdown placement="bottomRight" popupRender={() => profileMenu} trigger={["click"]}>
      <div className="nav-item" style={{ cursor: "pointer" }}>
        <div className="d-flex align-items-center justify-content-center ">
          <Avatar src={user.displayImage || profileImg} />
        </div>
      </div>
    </Dropdown>
  );
};

export default connect(null, { signOut })(NavProfile);
